import github_icon from '../assets/images/github_icon.svg';
import li_icon from '../assets/images/linkedin_icon.svg';
import as_icon from '../assets/images/artstation_icon.svg';
import ig_icon from '../assets/images/instagram_icon.svg';

export const Footer = () => {
  return (
    <div className='footer-container'>
      <div>Copyright 2026 © Krista Goralczyk. Built with React &#38; Sass, <a href='https://github.com/kristajg/kg-portfolio-site' target='_blank' rel='noreferrer'>view source code here</a>.</div>
      <hr />
      <a title='Github' href='https://github.com/kristajg' target='_blank' rel="noreferrer">
        <img src={github_icon} alt='Github Icon' />
      </a>
      <a title='Linkedin' href='https://www.linkedin.com/in/krista-goralczyk-037a1861/' target='_blank' rel="noreferrer">
        <img src={li_icon} alt='Linkedin Icon' />
      </a>
      <a title='Artstation' href='https://www.artstation.com/stratosyr' target='_blank' rel="noreferrer">
        <img src={as_icon} alt='Artstation Icon' />
      </a>
      <a title='Linkedin' href='https://www.instagram.com/kristajg_art' target='_blank' rel="noreferrer">
        <img src={ig_icon} alt='Instagram Icon' />
      </a>
    </div> 
  );
}
